
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/info/[code]",
      function () {
        return require("private-next-pages/brand/info/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/info/[code]"])
      });
    }
  